var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37331 0 0 5.37331 0 12C0 18.6267 5.37331 24 12 24C13.1067 24 14 23.1067 14 22C14 21.48 13.8067 21.0133 13.48 20.66C13.1667 20.3067 12.98 19.8467 12.98 19.3333C12.98 18.2266 13.8733 17.3333 14.98 17.3333H17.3333C21.0133 17.3333 24 14.3466 24 10.6666C24 4.77331 18.6267 0 12 0ZM4.66669 12C3.56 12 2.66669 11.1067 2.66669 10C2.66669 8.89331 3.56 8 4.66669 8C5.77338 8 6.66669 8.89331 6.66669 10C6.66669 11.1067 5.77331 12 4.66669 12ZM8.66669 6.66669C7.56 6.66669 6.66669 5.77338 6.66669 4.66669C6.66669 3.56 7.56 2.66669 8.66669 2.66669C9.77338 2.66669 10.6667 3.56 10.6667 4.66669C10.6667 5.77338 9.77331 6.66669 8.66669 6.66669ZM15.3333 6.66669C14.2266 6.66669 13.3333 5.77338 13.3333 4.66669C13.3333 3.56 14.2266 2.66669 15.3333 2.66669C16.44 2.66669 17.3333 3.56 17.3333 4.66669C17.3333 5.77338 16.44 6.66669 15.3333 6.66669ZM19.3333 12C18.2266 12 17.3333 11.1067 17.3333 10C17.3333 8.89331 18.2266 8 19.3333 8C20.44 8 21.3333 8.89331 21.3333 10C21.3333 11.1067 20.44 12 19.3333 12Z",
    fill: "#50429B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideShow);
export default __webpack_public_path__ + "static/media/slide-show.6df54b5998e771bfccc1e316d33c1623.svg";
export { ForwardRef as ReactComponent };